import { render } from "./BoxTransition.vue?vue&type=template&id=1bb762b8&scoped=true&ts=true"
import script from "./BoxTransition.vue?vue&type=script&lang=ts"
export * from "./BoxTransition.vue?vue&type=script&lang=ts"

import "./BoxTransition.vue?vue&type=style&index=0&id=1bb762b8&lang=scss&scoped=true"

import exportComponent from "/Users/mayo/htdocs/halp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb762b8"]])

export default __exports__